import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'zh-cn',
    fullName: 'Chinese (China)',
    nativeName: '中文（中国）',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "精空",
    landing_title: "令人惊奇的事情即将到来",
    landing_subtitle: "ArgVoid 是一家应用程序和游戏开发工作室。请继续关注，新内容即将推出！",
    select_language: "选择语言",
    search_placeholder: "搜索语言...",
    terms_title: "服务条款",
    policy_title: "隐私政策",
    cookies_title: "Cookie 政策",
    terms_content: `
        <strong>1。接受条款</strong><br>
        访问 ArgVoid 即表示您接受这些服务条款。如果不同意这些条款，则不应使用该服务。<br><br>

        <strong>2。平台使用</strong><br>
        ArgVoid 及其应用程序“按原样”提供，用于信息和创意目的。该服务只能用于合法目的。<br><br>

        <strong>3。禁止行为</strong><br>
        严格禁止利用站点漏洞、发送垃圾邮件或尝试未经授权访问基础设施。<br><br>

        <strong>4。免责声明</strong><br>
        平台和服务可能随时修改，恕不另行通知。不提供有关服务的正常运行时间或可用性的保证。
    `,
    policy_content: `
        <strong>1。信息收集</strong><br>
        该平台目前不需要用户身份验证或帐户创建。不会主动收集访客的个人身份信息（例如姓名或电子邮件地址）。<br><br>

        <strong>2。使用数据</strong><br>
        可以收集基本的匿名分析来了解站点流量并改进应用程序。该数据与个人用户身份无关。<br><br>

        <strong>3。第三方服务</strong><br>
        第三方提供商可用于托管和分析服务。这些各自提供商的隐私惯例管理在其基础设施上处理的匿名数据。<br><br>

        <strong>4。数据安全</strong><br>
        实施合理的安全措施来保护平台。然而，没有一种互联网传输方法是完全安全的。<br><br>
    `,
    cookies_content: `
        <strong>1。什么是 Cookie 和本地存储？</strong><br>
        Cookie 和浏览器本地存储是存储在设备上的小数据文件，用于记住访问期间的配置偏好。<br><br>

        <strong>2。使用目的</strong><br>
        浏览器LocalStorage严格用于保存配置设置，如：<br>
        - 语言偏好<br>
        - 用户界面配置（例如布局或主题设置）<br>
        - 临时应用程序缓存<br><br>

        <strong>3。无追踪</strong><br>
        Cookie 和本地存储不用于广告或第三方跟踪目的。所有存储的数据均严格用于平台的核心功能。<br><br>

        <strong>4。控制</strong><br>
        可以随时通过浏览器设置清除浏览器数据，这将重置所有本地配置。
    `,
    cookie_consent_text: "我们使用基本 cookie 来确保网站正常运行，例如保持您的会话处于活动状态、保存您的语言首选项以及其他自定义配置。",
    read_policy: "阅读 Cookie 政策",
    support_title: "联系支持人员",
    support_subject_label: "主题",
    support_message_label: "信息",
    support_submit_button: "发送消息",
    support_hint: "注意：这将打开您的默认电子邮件应用程序来发送消息。",
    support_success_msg: "打开您的电子邮件应用程序...",
    support_error_msg: "发送消息失败。请稍后重试。",
    explorer_title: "探险家",
    history_title: "历史",
    animation_title: "动画片",
    config_title: "配置",
    tool_mouse: "选择（Ctrl+M）",
    tool_brush: "画笔（Ctrl+B）",
    tool_brush_mode: "切换模式（稳定/清晰）",
    tool_eraser: "橡皮擦 (Ctrl+E)",
    tool_brush_size: "调整画笔大小",
    tool_bucket: "填充 (Ctrl+F)",
    tool_eyedropper: "滴管",
    tool_grid: "网格 (Ctrl+Shift+B)",
    tool_rotate: "旋转（Ctrl+Shift+R）",
    tool_flip_h: "翻转 H (Ctrl+Shift+H)",
    tool_flip_v: "翻转 V (Ctrl+Shift+V)",
    tool_transpose: "转置 (Ctrl+Shift+T)",
    label_width: "宽度",
    label_height: "高度",
    label_frames: "帧数",
    label_animation: "动画风格",
    label_background_color: "背景颜色",
    label_interval: "间隔",
    tool_anim_config: "动画配置",
    label_new_width: "新宽度",
    label_new_height: "新高度",
    label_apply: "申请",
    label_colors: "颜色",
    label_size: "尺寸",
    label_tolerance: "宽容",
    val_horizontal: "水平的",
    val_vertical: "垂直的",
    val_sequence: "顺序",
    val_bounce: "弹跳",
    val_random: "随机的",
    val_solid: "坚硬的",
    val_clear: "清除",
    action_add_sheet: "新表",
    action_import: "进口",
    action_export: "出口",
    action_sort_projects: "种类",
    sort_date_old: "最旧的在前",
    sort_date_new: "最新第一",
    sort_name_az: "姓名（A-Z）",
    sort_name_za: "姓名（Z-A）",
    action_new_sprite: "新雪碧",
    action_new_project: "新项目",
    modal_save_all_title: "保存所有更改",
    modal_save_all_desc: "选择要保存的资产：",
    modal_save_selected: "保存所选内容",
    action_saved: "已保存",
    modal_create_sprite_title: "创建新精灵",
    modal_create_project_title: "创建新项目",
    modal_add_sheet_title: "添加新工作表",
    modal_rename_sheet_title: "重命名工作表",
    modal_rename_sprite_title: "重命名精灵",
    modal_delete_sprite_title: "删除精灵",
    modal_delete_project_title: "删除项目",
    modal_delete_sheet_title: "删除工作表",
    placeholder_sprite_name: "姓名",
    placeholder_project_name: "姓名",
    placeholder_sheet_name: "姓名",
    placeholder_new_name: "新名称",
    action_create: "创造",
    action_add: "添加",
    action_rename: "重命名",
    action_duplicate: "复制",
    action_delete: "删除",
    action_cancel: "取消",
    confirm_delete_sprite: "您确定要删除这个精灵吗？",
    confirm_delete_project: "您确定要删除该项目吗？所有精灵都将被删除。",
    confirm_delete_sheet: "您确定要删除此工作表吗？",
    err_select_sprite: "请先选择一个精灵。",
    err_select_project: "请先选择一个项目。",
    err_name_empty: "名称不能为空。",
    err_sprite_exists: "具有该名称的精灵已存在。",
    err_project_exists: "具有该名称的项目已存在。",
    err_no_content: "没有要保存的内容。",
    err_no_changes: "没有要保存的更改。",
    err_delete_last_sheet: "无法删除最后一张纸。",
    err_extract_frames: "无法提取任何帧。",
    err_indexeddb: "本地保存失败。您的浏览器可能不支持 IndexedDB。",
    msg_upload_success: "上传成功：{0}",
    msg_upload_failed: "上传失败：{0}",
    msg_save_success: "保存成功。",
    msg_saving: "保存...",
    msg_multi_save_result: "已保存 {0} 个资源。 {1} 失败。",
    menu_title: "菜单",
    menu_save: "节省",
    menu_save_all: "全部保存",
    menu_support: "联系支持人员",
    label_local_storage: "本地存储",
    label_sign_in: "登入",
    modal_export_title: "导出精灵",
    label_filename: "文件名",
    label_format: "格式",
    action_export_confirm: "出口",
};

export default translations;
